// api.js

import { BASE_API_URL } from "../services/baseServices";

export const refreshAccessToken = async () => {
    const refreshToken = sessionStorage.getItem("refreshToken");

    const response = await fetch(`${BASE_API_URL}Public/refreshToken`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ "refreshToken": refreshToken }),
    });

    if (!response.ok) {
        sessionStorage.clear();
        localStorage.clear();
        window.location.href = "/"; // force logout
        return null;
    }

    const result = await response.json();
    sessionStorage.setItem("accessToken", result.data.accessToken);
    return result.data.accessToken;
};

export const fetchWithAuth = async (url, options = {}) => {
  const headers = {
    ...options.headers,
  };

  // Don't set Content-Type for FormData
  if (!(options.body instanceof FormData)) {
    headers["Content-Type"] = "application/json";
  }

  const res = await fetch(BASE_API_URL + url, {
    ...options,
    headers,
  });

  if (!res.ok) {
    throw new Error(`HTTP error! status: ${res.status}`);
  }

  return res;
};
